// extracted by mini-css-extract-plugin
export default {"button":"sort-header_button__VWyFT"};